import { Route } from 'react-router-dom'

import Creator from './screens/Creator'
import Edit from './screens/Edit'
import Form from './screens/Form'
import User from './screens/User'

const TournamentsRouter = () => (
  <Route path="/tournaments_v2">
    <Route element={<Form />} path="" />
    <Route element={<Creator />} path="create" />
    <Route element={<Edit />} path=":id/edit" />
    <Route element={<User />} path="user" />
  </Route>
)

TournamentsRouter.displayName = 'TournamentsRouter'

export default TournamentsRouter
